import MyInfoComp from "../../../components/mypage/myInfo/MyInfoComp";

function MyInfo() {

  return (
    <MyInfoComp/>
  );
}

export default MyInfo;